'use strict'

class SecurityPassword {

    static check (password){
        var level = SecurityPassword.isLength(password) ? 0 : -1;
        level += /[A-Z]/.test(password) || /[a-z]/.test(password) ? 1 : 0;
        level += /[0-9]/.test(password) ? 1 : 0;
        level += /[._-]/.test(password) ? 1 : 0;
        return level
    }

    static isEqual (pw, pw2){
        return pw === pw2 ? true : false;
    }

    static isLength (password){
        return password.length >= 8 && password.length <= 16 ? true : false;
    }

    static isAllowedCharacters (password){
        return password.replace(/[a-zA-Z0-9@._-]/g, '').length > 0 ? false : true;
    }

    static isEmpty (password){
        return password === '' ? true : false;
    }

    static isWhich(e){
        return e.which === undefined || e.which <= 90 && e.which >= 48 || e.which >= 96 && e.which <= 105 || 
        e.which === 8 || 
        e.which === 46 || 
        e.which === 225 || 
        e.which === 109 || 
        e.which === 189 || 
        e.which === 110 || 
        e.which === 190;
    }
}

export default SecurityPassword;